import React from 'react';

function PencilIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
    >
      <g id="Page-1" stroke="none" strokeWidth="1">
        <g id="Styleguide-Copy-2" transform="translate(-400.000000, -877.000000)" fill="#0E0E11">
          <g id="ic_edit_16px" transform="translate(400.000000, 877.000000)">
            <path d="M1.041,16 C0.77,16 0.505,15.894 0.306,15.696 C0.035,15.423 -0.065,15.028 0.043,14.663 L1.113,11.025 C1.162,10.858 1.253,10.705 1.376,10.582 L11.653,0.305 C12.046,-0.088 12.733,-0.088 13.126,0.305 L15.695,2.874 C15.892,3.07 16,3.332 16,3.61 C16,3.888 15.892,4.15 15.695,4.346 L5.418,14.624 C5.295,14.747 5.142,14.838 4.975,14.887 L1.335,15.957 C1.238,15.986 1.14,16 1.041,16 Z M1.922,11.835 L1.002,14.946 L4.161,14.074 L1.922,11.835 Z M2.437,10.936 L5.061,13.56 L12.707,5.92 L10.08,3.293 L2.437,10.936 Z M10.786,2.586 L13.413,5.213 L14.988,3.64 L12.39,1 C12.378,1 12.369,1.004 12.361,1.012 L10.786,2.586 Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default PencilIcon;
